// extracted by mini-css-extract-plugin
export var brand = "_6x-9";
export var compact = "_6x-6";
export var extraSmall = "_6x-7";
export var icon = "_6x-0";
export var large = "_6x-4";
export var light = "_6x-1";
export var medium = "_6x-5";
export var outline = "_6x-b";
export var primaryDark = "_6x-a";
export var primaryLight = "_6x-8";
export var primaryModern = "_6x-c";
export var success = "_6x-2";
export var successSolid = "_6x-3";